import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getJadwalTc = 'jadwal-test-center';
const postJadwalTcUrl = 'jadwal-test-center';
const putJadwalTc = 'jadwal-test-center/';
const deleteJadwalTc = 'jadwal-test-center/';
const getJadwalTcWithIdTc = 'jadwal-test-center/test-center';
class MasterJadwalTcService {
    
    getJadwalTc(currentPage) {
        return axios.get(
            API_URL + getJadwalTc + '?pageNo=' + currentPage + '&pageSize=10',
            {
                headers: authHeader()
            });
    }

    getJadwalTcWithIdTc(idTc,currentPage,pageSize,filter)
    {
        return axios.get(
        API_URL + getJadwalTcWithIdTc + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&idTc=' + idTc,
        {
            headers: authHeader()
        });
    }

    postJadwalTc(formData) {        
        return axios
        .post(
            API_URL + postJadwalTcUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putJadwalTc(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putJadwalTc + formData.idJadwalTc, formData,
            { headers: authHeader() }
        );
    }

    deleteJadwalTc(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteJadwalTc + formData.idJadwalTc,
                { headers: authHeader() }
            );
    }

}

export default new MasterJadwalTcService();
